var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React, { useEffect, useState } from 'react';
import { Box, Card, Flex, Image, Tooltip, getPaletteColor } from 'pcln-design-system';
import { Dot } from 'pcln-icons';
import styled, { keyframes, css } from 'styled-components';
var TRAVEL_BOT_LOGO = 'https://s1.pclncdn.com/design-assets/pcln-bot/logos/pcln_bot_opener_logo_no_border_v1.1.svg';
var CircleCard = /*#__PURE__*/styled(Card).withConfig({
  displayName: "StickyChatBotOpener__CircleCard",
  componentId: "sc-ie1md5-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 60px;\n  height: 60px;\n  background-color: ", ";\n  transition: 0.2s ease-in-out;\n  border: none;\n  box-shadow: ", ";\n\n  &:hover {\n    cursor: pointer;\n    box-shadow: ", ";\n  }\n"], ["\n  width: 60px;\n  height: 60px;\n  background-color: ", ";\n  transition: 0.2s ease-in-out;\n  border: none;\n  box-shadow: ", ";\n\n  &:hover {\n    cursor: pointer;\n    box-shadow: ", ";\n  }\n"])), getPaletteColor('primary.base'), function (_a) {
  var theme = _a.theme;
  return theme.shadows.md;
}, function (_a) {
  var theme = _a.theme;
  return theme.shadows.lg;
});
var StyledDot = /*#__PURE__*/styled(Dot).withConfig({
  displayName: "StickyChatBotOpener__StyledDot",
  componentId: "sc-ie1md5-1"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  right: -8px;\n  top: -5px;\n"], ["\n  position: absolute;\n  right: -8px;\n  top: -5px;\n"])));
var fadeInFromBottomToTopAnimation = function (props) {
  var animation = /*#__PURE__*/keyframes(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  from {\n       transform: translate(", ", ", ");\n      -webkit-transform: translate(", ", ", ");\n       opacity: 0;\n    }\n\n    to {\n       transform: translate(", ", ", ");\n       opacity: 1;\n    }\n  "], ["\n  from {\n       transform: translate(", ", ", ");\n      -webkit-transform: translate(", ", ", ");\n       opacity: 0;\n    }\n\n    to {\n       transform: translate(", ", ", ");\n       opacity: 1;\n    }\n  "])), props.fromX, props.fromY, props.fromX, props.fromY, props.toX, props.toY);
  return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: relative;\n    animation: ", ";\n    animation-duration: 0.4s;\n    animation-fill-mode: forwards;\n    animation-timing-function: cubic-bezier(0, 0, 0.3, 1);\n  "], ["\n    position: relative;\n    animation: ", ";\n    animation-duration: 0.4s;\n    animation-fill-mode: forwards;\n    animation-timing-function: cubic-bezier(0, 0, 0.3, 1);\n  "])), animation);
};
var AnimateBottomToTop = /*#__PURE__*/styled.div.withConfig({
  displayName: "StickyChatBotOpener__AnimateBottomToTop",
  componentId: "sc-ie1md5-2"
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n"], ["\n  ", "\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n"])), fadeInFromBottomToTopAnimation);
var AnimateComponent = function (_a) {
  var children = _a.children,
    animationProperties = _a.animationProperties,
    animationType = _a.animationType;
  if (animationType === 'BottomToTop') {
    var bottom = animationProperties.bottom,
      from = animationProperties.from,
      to = animationProperties.to;
    return React.createElement(AnimateBottomToTop, {
      fromX: from.x,
      fromY: from.y,
      toX: to.x,
      toY: to.y,
      bottom: bottom
    }, children);
  }
  return children;
};
/**
 * StickyChatBotOpener Component
 * @public
 */
export var StickyChatBotOpener = function (props) {
  var isChatBoxOpened = props.isChatBoxOpened,
    onComponentRendered = props.onComponentRendered,
    onClickHandler = props.onClickHandler,
    openerPosition = props.openerPosition,
    _a = props.animationType,
    animationType = _a === void 0 ? 'None' : _a,
    animationProperties = props.animationProperties;
  var _b = useState(false),
    isTooltipOpen = _b[0],
    setIsOpen = _b[1];
  var _c = useState(false),
    isSectionActive = _c[0],
    setIsSectionActive = _c[1];
  useEffect(function () {
    onComponentRendered();
  }, []);
  useEffect(function () {
    if (isChatBoxOpened && !isSectionActive) {
      setIsSectionActive(true);
    }
  }, [isChatBoxOpened]);
  function onMouseOver() {
    setIsOpen(true);
  }
  function onMouseOut() {
    setIsOpen(false);
  }
  var openerTooltipProps = props.openerTooltipProps || {};
  var tooltipProps = __assign({
    top: true,
    center: true,
    bg: 'black',
    color: 'white'
  }, openerTooltipProps);
  return React.createElement(AnimateComponent, {
    animationType: animationType,
    animationProperties: animationProperties
  }, React.createElement(CircleCard, {
    style: __assign({
      position: 'fixed',
      right: '32px',
      bottom: '32px'
    }, openerPosition),
    borderRadius: 50,
    "data-testid": 'openChatBotDialog',
    onClick: onClickHandler,
    onMouseOver: onMouseOver,
    onMouseOut: onMouseOut
  }, isTooltipOpen && React.createElement(Tooltip, __assign({
    p: 1,
    style: __assign({
      bottom: '-2px'
    }, props.openerTooltipStyle)
  }, tooltipProps), React.createElement(Box, {
    width: '110px'
  }, "Chat with Penny")), React.createElement(Flex, {
    alignItems: 'center'
  }, React.createElement(Image, {
    src: TRAVEL_BOT_LOGO,
    width: 60,
    alt: 'Penny chat opener'
  })), isSectionActive && !isChatBoxOpened && React.createElement(StyledDot, {
    size: 32,
    color: 'warning.tone'
  })));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;